import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Action, State, StateContext } from "@ngxs/store";
import { createRequestAction, RequestState } from "ngxs-requests-plugin";

import { environment } from "../../../../environments/environment";
import { patchIdsAndEntities } from "../../../shared/utils/patch-ids-and-entities";
import { GetDownloadOptions, GetDownloadOptionsFail, GetDownloadOptionsSuccess } from "./download-options.actions";
import { IMetaOption } from "../../interfaces/meta-options.interface";

export interface DownloadOptionsStateModel {
  ids: number[];
  entities: {[key: number]: IMetaOption}
}

@RequestState('getDownloadOptions')
@Injectable()
export class GetDownloadOptionsRequestState {}

@State<DownloadOptionsStateModel>({
  name: 'downloadOptions',
  defaults: {
    ids: [],
    entities: {}
  }
})
@Injectable()
export class DownloadOptionsState {
  constructor(
    private http: HttpClient,
  ) {}

  @Action(GetDownloadOptions)
  getExtraOptions(
    { dispatch }: StateContext<DownloadOptionsStateModel>
  ) {
    const request = this.http.get(environment.api + 'db/meta/download_options');

    return dispatch(
      createRequestAction({
        request,
        state: GetDownloadOptionsRequestState,
        successAction: GetDownloadOptionsSuccess,
        failAction: GetDownloadOptionsFail
      })
    );
  }

  @Action(GetDownloadOptionsSuccess)
  getExtraOptionsSuccess(
    ctx: StateContext<DownloadOptionsStateModel>,
    { payload: response }: GetDownloadOptionsSuccess
  ) {
    const downloadOptions = Object.keys(response.content).map(key => {
      return {tag: key, ...response.content[key]};
    });

    patchIdsAndEntities(ctx, downloadOptions, true, 'tag');
  }
}